export default "__VITE_ASSET__CL2A4E8t__"